<template>
  <div class="the-navbar__user-meta flex items-center" v-if="activeUserInfo.displayName">

    <div class="text-right leading-tight hidden sm:block">
      <p class="font-semibold">{{ current_user.name }}</p>
      <small>{{ current_user.role ? current_user.role.name : 'Online' }}</small>
    </div>

    <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">

      <div class="con-img ml-3">
        <vs-avatar v-if="!current_user.avatar" size="40px" color="primary" :text="current_user.name" class="rounded-full shadow-md cursor-pointer block"/>
        <img v-if="current_user.avatar" key="onlineImg" :src="current_user.avatar" alt="avatar" width="40" height="40" class="rounded-full shadow-md cursor-pointer block" />
      </div>

      <vs-dropdown-menu class="vx-navbar-dropdown">
        <ul style="min-width: 9rem">

          <router-link to="/pages/user-settings">
            <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white">
              <feather-icon icon="UserIcon" svgClasses="w-4 h-4" />
              <span class="ml-2">Profile</span>
            </li>
          </router-link>

          <vs-divider class="m-1" />

          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="logouts">
            <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Logout</span>
          </li>
        </ul>
      </vs-dropdown-menu>
    </vs-dropdown>
  </div>
</template>

<script>
  import {
    mapActions
  } from 'vuex'
  import store from '@/store/store.js'


  export default {
  data() {
      return {
        current_user : {}
      }
    },
  computed: {
    activeUserInfo () {
      return this.$store.state.AppActiveUser
    }
  },

  methods: {
    ...mapActions(['logout']),
    async logouts () {
      localStorage.removeItem('userInfo')

      // This is just for demo Purpose. If user clicks on logout -> redirect
      // this.$router.push('/pages/login').catch(() => {})
      await this.logout()
    }
  },
    mounted() {
      this.current_user = store.getters.currentUser
    }
  }
</script>
